export default "__VITE_ASSET__973f527e__"